import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { AiFillStar } from 'react-icons/ai';
import './topOffer.css'
import ConversionEvents from '../ConversionEvents/ConversionEvents';
import { formatUSD } from '../../utils/money';

// Define a mapping of device names to their corresponding image paths
const deviceImages = {
  macos: '/macos.png',
  windows: '/windows.png',
  android: '/androidicon.svg',
  iphone: '/iphoneicon.png',
  ipad: '/ipad.svg',
  ios: '/ios.png', // Add ios.png for iPad and iPhone combined
};

/* eslint-disable react/prop-types */
// eslint-disable-next-line react/prop-types
const TopOffer = ({
    // eslint-disable-next-line react/prop-types
    title_text,
    center_text,
    image_game,
    devices,
    link,
    reward_payout,
    events,
    rank,
    isHot,
    hotLabel = '🔥 BEST PAYOUT',
    playingNow,
    ratingsCount,
    ratingsAvg,
    glimmer,
    directLink = false
  }) => {
  
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // Surveys are single-step: skip the milestone sheet and go straight out.
  const handleCardClick = () => {
    if (directLink && link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    } else {
      openModal();
    }
  };

  // First-party surface: integer-coin rewards displayed as USD.
  const displayReward =
    isNaN(reward_payout) || reward_payout === 'variable'
      ? '∞'
      : formatUSD(reward_payout);

  // Determine which device icons to display
  const renderDeviceIcons = () => {
    const hasIpad = devices.includes('ipad');
    const hasIphone = devices.includes('iphone');

    // Check if both iPad and iPhone are present
    if (hasIpad && hasIphone) {
      return <img key="ios" src={deviceImages.ios} alt="iOS icon" width={30} />;
    }

    return devices.map(device => (
      deviceImages[device] ? (
        <img key={device} src={deviceImages[device]} alt={`${device} icon`} width={30} />
      ) : null
    ));
  };

  // CPX rating fields may arrive as strings; normalize, else hide.
  const ratingsNumber =
    ratingsCount === undefined || ratingsCount === null || ratingsCount === '' || isNaN(Number(ratingsCount))
      ? null
      : Number(ratingsCount);
  const ratingsAvgNumber =
    ratingsAvg === undefined || ratingsAvg === null || ratingsAvg === '' || isNaN(Number(ratingsAvg))
      ? null
      : Number(ratingsAvg);

  // Only render the icon pill when at least one device actually has an
  // icon (e.g. surveys pass devices=['*'], which matches nothing).
  const deviceIconList = devices ? React.Children.toArray(renderDeviceIcons()) : [];

  // Survey cards carry no art: text goes full-width, rank badge pins to
  // the card corner instead of the (absent) artwork.
  const hasImage = Boolean(image_game);

  return (
    <>
      <div className="carousel-container">
        <div className={`card${isHot ? ' hot' : ''}`} onClick={handleCardClick}>
          {isHot && <div className="hot-ribbon" aria-hidden="true">{hotLabel}</div>}
          <div className="top-row">
            {hasImage && (
            <div className="first">
              {typeof rank === 'number' && rank < 3 && (
                <div className={`rank-badge rank-${rank + 1}`} aria-hidden="true">#{rank + 1}</div>
              )}
              <div className="gameLogo">
                <img src={image_game} alt="" width={100} />
              </div>
              {deviceIconList.length > 0 && (
                <div className="device-icons">
                  {deviceIconList}
                </div>
              )}
            </div>
            )}
            {!hasImage && typeof rank === 'number' && rank < 3 && (
              <div className={`rank-badge rank-${rank + 1} rank-corner`} aria-hidden="true">#{rank + 1}</div>
            )}
            <div className="second">
              <div className="heading">
                <h1 className="poppins-bold">{title_text}</h1>
              </div>
              {typeof playingNow === 'number' && (
                <div className="playing-now" aria-label={`${playingNow} people playing now`}>
                  <span className="live-dot" aria-hidden="true" />
                  {playingNow.toLocaleString()} playing now
                </div>
              )}
              {(ratingsNumber !== null || ratingsAvgNumber !== null) && (
                <div
                  className="playing-now"
                  aria-label={`${ratingsNumber !== null ? `${ratingsNumber.toLocaleString()} ratings` : ''}${ratingsNumber !== null && ratingsAvgNumber !== null ? ', ' : ''}${ratingsAvgNumber !== null ? `average ${ratingsAvgNumber} stars` : ''}`}
                >
                  <span className="live-dot" aria-hidden="true" />
                  {ratingsNumber !== null && <>{ratingsNumber.toLocaleString()} ratings</>}
                  {ratingsNumber !== null && ratingsAvgNumber !== null && <span aria-hidden="true">•</span>}
                  {ratingsAvgNumber !== null && (
                    <span className="ratings-avg">
                      <AiFillStar className="rating-star" aria-hidden="true" /> {ratingsAvgNumber}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className={`third${glimmer ? ' jackpot' : ''}`}>
            <div className="reward-inner">
              <p className="poppins-bold reward-amount">+{displayReward}</p>
            </div>
          </div>
        </div>
      </div>

      {showModal && ReactDOM.createPortal(
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="close-button" onClick={closeModal}>×</button>
            <ConversionEvents
              description={center_text}
              events={events}
              totalReward={displayReward}
              devices={devices}
              link={link}
              isDollars
            />
          </div>
        </div>,
        document.body
      )}
    </>
  );
};
  
export default TopOffer;